export default __webpack_public_path__ + "static/media/horse-realistic-3.19f8210e.svg";